// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-order-list__item__content__caption[data-v-295780ec]{color:#ff7272;font-size:.85rem}.p-order-list__item__content__cannot-cancel[data-v-295780ec]{color:#ff7272;font-size:.85rem;text-align:center}", ""]);
// Exports
module.exports = exports;
